import { AuthService } from 'src/app/core/services/auth.service';
import { Injectable } from '@angular/core';
import { CookieService } from './cookie.service';
import { User } from '../models/user.model';
import { firstValueFrom } from 'rxjs';
import { Utils } from 'src/app/shared/utils/utils';

@Injectable({
	providedIn: 'root'
})
export class UserDataService {
	public user: User;

	constructor(
		private readonly cookieService: CookieService,
		private readonly authService: AuthService
	) { }

	public async getUser(): Promise<User> {
		if (this.user) {
			return this.user;
		}

		const userData = this.cookieService.get('active-user');
		if (userData) {
			this.user = JSON.parse(userData) as User;
			return this.user;
		}

		const authData = this.cookieService.get('authResponse');
		if (authData) {
			let authModel = JSON.parse(authData);
			try {
				const user = await firstValueFrom(this.authService.getUserDetails(authModel));
				this.user = user;
				
				const blob = Utils.base64ToBlob(this.user.image, 'image/jpeg');
				this.user.image = URL.createObjectURL(blob);

				this.cookieService.set('active-user', JSON.stringify(user), undefined, '/');
				return this.user;
			} catch (err) {
				console.error('Error fetching user details:', err);
				this.authService.logout();
				throw err;
			}
		}

		this.authService.logout();
		throw new Error('User not authenticated');
	}

	public clearUser(): void {
		this.cookieService.delete('active-user');
		this.user = null;
	}
}